import { type UseQueryResult, useQuery } from 'react-query';
import { PsuElectionWindowConfigurationService } from '@wealthlane/api-services/wealthlane-award-settlement-service';
import { PsuAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetPsuAwardPerformanceRuleDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  awardId: string,
  isApprover?: boolean
): any => {
  const psuAwardPerformanceRuleDetails = useQuery(
    ['getPsuAwardPerformanceRuleDetails'],
    async () => {
      if (awardId && !isApprover) {
        return await handleRequest(
          PsuAwardService.getApiAwardApiAppPSUAwardPerformanceRuleForAdminDetail(awardId)
        );
      }
    }
  );
  return psuAwardPerformanceRuleDetails;
};

export default useGetPsuAwardPerformanceRuleDetails;
